import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const PinterestPinDescription = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14925)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FEF2F2"
          />
          <path
            d="M137.948 96.9033H96.0043L72.0364 114.879V96.9033H60.0525C56.8568 96.9033 54.0605 94.1073 54.0605 90.9112V30.992C54.0605 27.7962 56.8568 25 60.0525 25H137.948C141.144 25 143.94 27.7962 143.94 30.992V90.9112C143.94 94.1073 141.144 96.9033 137.948 96.9033Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="63"
            y="61.9395"
            width="77"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="63"
            y="69.9395"
            width="61"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="63"
            y="77.9395"
            width="43"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <circle
            cx="67"
            cy="38.9395"
            r="4"
            fill="#1E1E1E"
          />
          <rect
            x="75"
            y="36.9395"
            width="38"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="117"
            y="36.9395"
            width="20"
            height="4"
            rx="1"
            fill="#1E1E1E"
          />
          <path
            d="M117.353 108.171H147.821L165.232 121.229V108.171H173.937C176.258 108.171 178.29 106.14 178.29 103.818V60.2921C178.29 57.9707 176.258 55.9395 173.937 55.9395H117.353C115.031 55.9395 113 57.9707 113 60.2921V103.818C113 106.14 115.031 108.171 117.353 108.171Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M142.85 94.8853C143.983 96.1109 145.914 96.1302 147.072 94.9274L159.738 81.7648C162.349 79.1532 162.929 75.0908 161.479 71.6086C158.867 66.3855 151.613 65.2248 147.55 69.2872L145.229 71.6086L142.907 69.2872C138.555 64.9346 131.59 66.0953 128.979 71.6086C127.238 75.0908 127.818 79.1532 130.72 81.7648L142.85 94.8853Z"
            fill="#FF5A4F"
            stroke="black"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M144 50.9395H54V48.9395H144V50.9395Z"
            fill="black"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M169 36.9998C169 43.1419 172.694 48.4185 177.979 50.7384C177.937 49.691 177.971 48.4336 178.24 47.294C178.528 46.0763 180.17 39.1206 180.17 39.1206C180.17 39.1206 179.691 38.1629 179.691 36.7474C179.691 34.5245 180.979 32.8644 182.584 32.8644C183.948 32.8644 184.607 33.8892 184.607 35.1163C184.607 36.4878 183.732 38.5394 183.283 40.4395C182.907 42.0307 184.08 43.3285 185.65 43.3285C188.492 43.3285 190.406 39.6783 190.406 35.3535C190.406 32.066 188.192 29.6054 184.165 29.6054C179.614 29.6054 176.78 32.9986 176.78 36.7888C176.78 38.0956 177.165 39.0172 177.769 39.7308C178.046 40.0586 178.085 40.1904 177.984 40.5668C177.912 40.8428 177.747 41.5072 177.679 41.7705C177.579 42.1504 177.271 42.2862 176.928 42.146C174.832 41.2904 173.856 38.9954 173.856 36.4154C173.856 32.1545 177.449 27.0453 184.576 27.0453C190.303 27.0453 194.073 31.1894 194.073 35.6378C194.073 41.522 190.801 45.9179 185.979 45.9179C184.359 45.9179 182.836 45.0425 182.314 44.0482C182.314 44.0482 181.444 47.5042 181.259 48.1716C180.941 49.3281 180.319 50.484 179.749 51.3849C181.098 51.7831 182.524 52 184.001 52C192.284 52 199 45.2843 199 36.9998C199 28.7157 192.284 22 184.001 22C175.716 22 169 28.7157 169 36.9998Z"
            fill="#CB1F27"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14925">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
PinterestPinDescription.displayName = 'PinterestPinDescription';
